import { render, staticRenderFns } from "./RetailVendorMenu.vue?vue&type=template&id=3ad88f8c&scoped=true&"
import script from "./RetailVendorMenu.vue?vue&type=script&lang=js&"
export * from "./RetailVendorMenu.vue?vue&type=script&lang=js&"
import style0 from "./RetailVendorMenu.vue?vue&type=style&index=0&id=3ad88f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad88f8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
